import script from "./shejipingdingdetail.vue?vue&type=script&setup=true&lang=js"
export * from "./shejipingdingdetail.vue?vue&type=script&setup=true&lang=js"

import "./shejipingdingdetail.vue?vue&type=style&index=0&id=c94fc36a&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c94fc36a"]])

export default __exports__